import React from "react";
import store from '../store'
import {getTokenDetails} from "../providers/providers";

export default class BaseComponent extends React.Component {
    constructor(props) {
        super(props)
        const self = this;
        if (this.props.match !== undefined) {
            const path = this.props.match.path;
            store.dispatch(getTokenDetails()).then((response) => {
                if (response.value.status !== 200) {
                    if (path !== '/login') {
                        localStorage.clear();
                        self.props.history.push("/login")
                    }
                } else {
                    if (!path.endsWith('/payment/authentication') && !path.endsWith('/accessTokens') ) {
                        self.props.history.push("/")
                    }
                }
            }, (error) => {
                if (path !== '/login') {
                    localStorage.clear();
                    self.props.history.push("/login")
                }
            })
        }
    }
}